<template>
  <v-col cols="12" md="4" tile>
    <v-hover v-slot:default="{ hover }">
      <v-card light class="mx-auto" :elevation="hover ? 12 : 2" @click="open">
        <v-img
          :src="src"
          class="white--text"
          width="100%"
          
          contain
          gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
        >
          <v-card-title class="align-end fill-height pa-0 ma-0" style="font-size:1.4em; word-wrap: break-word;">
          <v-container>
              <v-row no-gutters>{{name}}</v-row>
          </v-container>  
          </v-card-title>
        </v-img>

        <v-card-text>
          <v-container>
              <v-row no-gutters>
                {{url}}
              </v-row>
            </v-container>
        </v-card-text>
      </v-card>
    </v-hover>
  </v-col>
</template>

<script>
import router from "@/plugins/router";

export default {
  props: ["id", "name", "url", "src", "color1", "color2", "apiKey"],
  name: "v-app-list-item",
  components: {},
  data: () => ({
    
  }),
  methods: {
    async open() {
      router.push("/apps/" + this.id);
    }
  },
  created() {},

  computed: {
  }
};
</script>

<style>
</style>